import React, { useCallback } from 'react';

import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';
import {
  NonWalletAccessBillingState,
  useNonWalletAccessBillingState,
  useNonWalletAccessDescription,
} from '../../../../../../hooks/non-wallet-access-hooks';
import { useSelectedBasePlan } from '../../../hooks/use-plan-details';
import { DeactivationMessage } from './deactivation-message';
import { isBillingPlanIdUsageBilledHighVolume } from '../../../../../../enums/billing-plan-ids';

import { messages } from './messages';
import style from './style.module.css';

export const YourCarriersSelectionToggle = () => {
  const { byoaEnabled, setByoaEnabled } = useManageSubscriptionDrawerContext();

  // if selected plan is a BYOA plan, for _display purposes_ we want to show it as the base plan from allPlans
  const selectedPlan = useSelectedBasePlan();
  const isHighVolumePlanSelected = isBillingPlanIdUsageBilledHighVolume(selectedPlan?.billingPlanId);
  const onByoaToggleChange = useCallback(() => setByoaEnabled((prev) => !prev), [setByoaEnabled]);

  const byoaBillingState = useNonWalletAccessBillingState();
  const byoaDescription = useNonWalletAccessDescription({ selectedPlan });
  const isToggleDisabled = isHighVolumePlanSelected || byoaBillingState === NonWalletAccessBillingState.Included;

  return (
    <div className={style['plan-feature']}>
      <div className={style['plan-row']}>
        <div className={style['toggle-container']}>
          <CheckboxSlider checkboxId='byoa-slider' checked={byoaEnabled} disabled={isToggleDisabled} onChange={onByoaToggleChange} />
          <Text textType={TextType.H4} value={messages.yourCarriers} />
        </div>
        <Text className={style['your-carriers-description']} textType={TextType.Caption} value={byoaDescription} />
      </div>
      <DeactivationMessage />
    </div>
  );
};
